
<mat-dialog-content>
  <h2 style="color: #FFF; font-size: 50px">{{labels.lblWrongAnswer}}</h2>
  <h3 style="color: #FFF;  font-size: 40px; margin-top: 20px; margin-bottom: 20px; line-height: normal" [innerHTML]="labels.lblWrongAnswerMessage + ' ' +  data" ></h3>
  <div style="margin: auto; text-align: center">
    <button class="button" mat-button (click)="onNoClick()" type="button"
            style="margin-top:15px;" matDialogClose>{{labels.lblConfirm}}</button>
  </div>

</mat-dialog-content>
